import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import BannerListService from '../services/BannerListService';
import BannerList from './BannerList';

class BannerListContainer extends React.Component {
  componentDidMount() {
    BannerListService.load();
  }

  render() {
    return (
      <BannerList
        banners={toJS(BannerListService.banners)}
        pagination={BannerListService.pagination}
        fetching={BannerListService.fetch.fetching}
        onChange={BannerListService.handleChange}
        onDelete={BannerListService.handleDelete}
      />
    );
  }
}

export default observer(BannerListContainer);
